import { ReactNode, useEffect, useState } from "react";
import { IHeaderSetters } from "../Journal";
import './RecapPage.css';
import { Card, Icons, LoadingBlock } from "../SharedComponents";
import { Route, Routes, useNavigate, useParams } from "react-router";
import { RecapEntriesViewModel, RecapEntryType } from "../../../ViewModel/RecapEntriesViewModel";
import React from "react";
import { GetCorrelation } from "../../../ViewModel/Utilities";
import { IDayStatus, WeeklyProgress } from "../SharedComponents/WeeklyProgress";
import { SimpleTextViewModel } from "../../../ViewModel";
import { IProperyChangedArgs } from "../../../Utilities";
import { appInsights } from "../../../Services/AppInsightsService";
// import recapHeaderBackground from '../SharedComponents/assets/png/reacp-header-background.png';
// import { useNavigate } from "react-router";src/AppRoutes/Journal/

export function RecapPage({ headerSetters }: { headerSetters: IHeaderSetters }) {
    console.log("RecapPage");
    return (
        <Routes>
            <Route path="/:recapId?/*" element={<RecapEntry headerSetters={headerSetters} />} />
        </Routes>
    )
}

export function RecapEntry({ headerSetters, Collapsed }: { headerSetters: IHeaderSetters, Collapsed?: boolean }) {

    const [isCollapsed, setIsCollapsed] = React.useState(Collapsed !== undefined ? Collapsed : false);
    const [viewModel, setViewModel] = React.useState<RecapEntriesViewModel | undefined>(undefined);
    const { recapId } = useParams();
    const navigate = useNavigate();
    const [progressEntries, setProgressEntries] = useState<IDayStatus[]>([]);


    useEffect(() => {

        let vm: RecapEntriesViewModel | null = null;
        const updateEntries = (e: IProperyChangedArgs) => {

            if (e.property === 'WeeklyStatus' || e.property === 'isHydrated') {
                if (vm?.TypedData.entryType === RecapEntryType.Week)
                    setProgressEntries(vm.WeeklyStatus);
            }
        };

        if (viewModel === undefined) {
            (async () => {

                //
                // If we don't have a recap on the path, use the default
                //
                if (!recapId) {
                    let recaps = RecapEntriesViewModel.DisplayRecaps;
                    if (recaps.length === 0)
                        throw new Error("No recaps found");
                    vm = recaps[0];
                }
                else {
                    vm = await RecapEntriesViewModel.Manager.GetItemByKey(GetCorrelation(), recapId!);
                }

                //
                // If there is no vm, we have nothing to show... error out.
                //
                if (!vm) {
                    throw new Error("Recap not found");
                }


                await vm.Hydrate(GetCorrelation());

                vm.PropertyChanged.Subscribe(updateEntries);

                if (vm.TypedData.entryType === RecapEntryType.Week)
                    setProgressEntries(vm.WeeklyStatus);
                setViewModel(vm);
                vm.SetPageHeader(headerSetters);

            })();
        }





        return () => {
            vm?.PropertyChanged.Unsubscribe(updateEntries);
        }




    }, [headerSetters]);

    if (!viewModel) {
        appInsights.trackTrace({ message: 'RecapPageViewModelNotReady', properties: { reason: "viewModel is undefined", recapId: recapId } });
        return (<LoadingBlock />);
    }

    const headerCollapsed = isCollapsed ? "gl-collapsed" : "";

    const badgeBackgroundClass = `gl-badge-background-${viewModel.scoreColor}`;

    const RecapHeader = () => {
        return (
            <div className={`gl-recap-header ${headerCollapsed}`}>
                <div className='gl-recap-header-background' />
                <div className="gl-header-content h-full flex flex-row justify-content-between">
                    <div className="flex flex-row">
                        <div className={`${badgeBackgroundClass} gl-badge-background gl-color-badge-typohraphy color-white border-circle flex-none flex align-items-center justify-content-center`}>
                            {viewModel.score}
                        </div>
                        <div className="flex flex-column align-items-start">
                            <h3 className="gl-header-title gl-home-section-title ml-75">{viewModel.PageCardHeader}</h3>
                            {
                                viewModel.selectedAccomplishments.values.length > 0 &&
                                <p className="gl-header-subtitle gl-header-subtitle-typography"
                                >{viewModel.selectedAccomplishments.values.length} Top Accomplishments</p>
                            }
                            {
                                viewModel.selectedMagicMoments.values.length > 0 &&
                                <p className="gl-header-subtitle gl-header-subtitle-typography"
                                >{viewModel.selectedMagicMoments.values.length} Magic Moments</p>}
                        </div>
                    </div>
                    <div
                        className="flex justify-content-center align-items-center"
                        onClick={() => setIsCollapsed(
                            !isCollapsed
                        )}
                    >
                        {
                            !isCollapsed
                                ?
                                <Icons.ChevronUp className="gl-chevron-up" />
                                :
                                <Icons.ChevronDown className="gl-chevron-down " />
                        }
                    </div>
                </div>
                {
                    viewModel.TypedData.entryType !== "Day" &&
                    <div className="gl-header-content">
                        <WeeklyProgress statuses={progressEntries} />
                    </div>
                }
            </div>
        );
    }


    var isFirst = true;
    const ContentSection = ({ sectionTitle, icon, items, entry, isLast }: {
        sectionTitle: string,
        icon: ReactNode,
        items?: SimpleTextViewModel[],
        entry?: string,
        isLast?: boolean
    }) => {

        var shouldEdit = isFirst;
        isFirst = false;
        var lastClassname = isLast ? "last" : "";
        if ((!items || items.length === 0) && !entry) {
            return (
                <div className={`gl-recap-section gl-recap-section-header pt-150 flex flex-column justify-content-between  ${lastClassname}`}>

                    <div className="flex flex-row justify-content-between align-items-center">
                        {icon}

                        <div className="flex flex-row justify-content-between align-items-center flex-grow-1">
                            <p className="gl-recap-section-title m-0">{sectionTitle}</p>
                            {
                                shouldEdit
                                &&
                                <div onClick={() => navigate(viewModel.EditRoute)}>
                                    <Icons.EditIcon className="gl-recap-section-edit-icon mr-3" />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            );
        }



        return (
            <div className={`gl-recap-section gl-recap-section-header pt-150 flex flex-column justify-content-between  ${lastClassname}`}>

                <div className="flex flex-row justify-content-between align-items-center">
                    {icon}

                    <div className="flex flex-row justify-content-between align-items-center flex-grow-1">
                        <p className="gl-recap-section-title m-0">{sectionTitle}</p>
                        {
                            shouldEdit
                            &&
                            <div onClick={() => navigate(viewModel.EditRoute)}>
                                <Icons.EditIcon className="gl-recap-section-edit-icon mr-3" />
                            </div>
                        }
                    </div>
                </div>
                <ul className="gl-recap-section-items ">
                    {items ?
                        items.map(
                            (moment) =>
                            (
                                <li key={moment.TypedData.id}>{moment.TypedData.text}</li>
                            )
                        ) :
                        <li>{entry}</li>
                    }
                </ul>
            </div>

        );
    }



    return (
        <div className="gl-recap-page">
            <Card
                noMargin
                className="gl-recapPage-card"
                disableClick
            >
                <RecapHeader />
                {!isCollapsed &&
                    <div>
                        <ContentSection
                            sectionTitle={viewModel.PageTopAccomplishmentsText}
                            icon={<Icons.BlueRibbon className="gl-recap-section-icon flex-none" />}
                            items={viewModel.selectedAccomplishments.values}
                        />


                        <ContentSection
                            sectionTitle={viewModel.PageTopMagicMomentsText}
                            icon={<Icons.Star className="gl-recap-section-icon gl-recap-star-icon" />}
                            items={viewModel.selectedMagicMoments.values}
                        />


                        <ContentSection
                            sectionTitle={viewModel.PageDescriptionHeaderText}
                            icon={<Icons.SummaryIcon className="gl-recap-section-icon gl-recap-summary-icon" />}
                            entry={viewModel.TypedData.entry}
                            isLast
                        />
                    </div>}
            </Card>
        </div>
    );
}